import * as cx from 'classnames';
import * as React from 'react';
import { isKlarnaCheckout } from '../../../utils/paymentMethods';
import { evaluate } from '../../../utils/utils';
import * as Styles from './Widget.scss';

interface IOwnProps {
  snippet: string;
  selectedPaymentMethod?: string;
  evaluateDelay?: number;
  onUpdate?: () => void;
}

type Props = IOwnProps;

interface IOwnState {
  evaluateDelay: number;
}

class Widget extends React.Component<Props, IOwnState> {

  [x: string]: any;

  state: IOwnState = {
    evaluateDelay: this.props.evaluateDelay ? this.props.evaluateDelay : 0,
  };

  componentDidMount() {
    evaluate(this.frame);
  }

  componentDidUpdate() {
    const { onUpdate } = this.props;
    setTimeout(() => { evaluate(this.frame); }, this.state.evaluateDelay);
    if (onUpdate) {
      setTimeout(() => { onUpdate(); }, this.state.evaluateDelay + 100);
    }
  }

  shouldComponentUpdate(nextProps: Props) {
    return this.props.snippet !== nextProps.snippet;
  }

  render() {
    const { selectedPaymentMethod, snippet } = this.props;
    const widgetClassNames = cx({
      [Styles.widget]: true,
      [Styles.klarnaCheckout]: selectedPaymentMethod !== undefined && isKlarnaCheckout(selectedPaymentMethod),
    });

    return (
      <div className={widgetClassNames} ref={(node) => { this.frame = node; }}>
        <div dangerouslySetInnerHTML={{ __html: snippet }} />
      </div>
    );
  }
}

export default Widget;
